import Actions from "../../../constants/Actions";

const initialState = {
  isEventModal: false,
  isSubmit: false,
  selectionInfo: {
    name: "",
    description: "",
    start: "",
    end: "",
    defaultDuration: "",
    grade: "",
    board: "",
    subject: "",
    type: "",
    joinUrl: "",
    serviceName:""
  },
  eventInfo: {
    id: "",
    title: "", //means name in our case
    start: "",
    end: "",
    context: {},
  },
  localInfo: {
    id:"",   
    title: "",
    start: "",
    end: "",
    context: {},
  },
};

const eventModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ENABLE_CALENDAR_MODAL:      
      return {
        ...state,
        isEventModal: !state.isEventModal,
        selectionInfo: action.payload,
      };
    case Actions.DISABLE_CALENDAR_MODAL:
      return {
        ...state,
        isEventModal: !state.isEventModal,
      };
    case Actions.UPDATE_CALENDAR_FORM:
      return {
        ...state,
        selectionInfo: action.payload,
      };
    case Actions.CHANGE_END_TIME:
      return {
        ...state,
        selectionInfo: action.payload,
      };
    case Actions.CLEAR_FORM:
      return {
        ...state,
        selectionInfo: {},
      };
    case Actions.SUBMIT_SUCCESS:      
      return {
        ...state,
        isSubmit: action.payload,
      };
    case Actions.LOCAL_INFO: {
      return {
        ...state,
        localInfo: action.payload,
      };
    }
    case Actions.SUBMIT_FAILURE:
      return {
        ...state,
        isSubmit: false,
      };
    case Actions.POPULATE_TOOL_TIP:
      return {
        ...state,
        eventInfo: action.payload,
      };  
    case Actions.CLEAR_LOCAL_INFO:
      return {
        ...state,
        localInfo:action.payload
      }  
    default:
      return state;
  }
};

export default eventModalReducer;
